import axios from 'axios';
import { FeedbackSubmission, FeedbackApiResponse } from '../types/feedback';
import { API_BASE_URL } from '../config/api';

class FeedbackService {
  private baseURL: string;

  constructor() {
    this.baseURL = API_BASE_URL;
  }

  /**
   * Submit feedback to the backend
   */
  async submitFeedback(feedbackData: FeedbackSubmission): Promise<FeedbackApiResponse> {
    try {
      // Add metadata
      const submissionData = {
        ...feedbackData,
        metadata: {
          ...feedbackData.metadata,
          version: '1.0.0',
          sourceUrl: window.location.href,
          userAgent: navigator.userAgent,
          timestamp: new Date().toISOString(),
        }
      };

      const response = await axios.post(
        `${this.baseURL}/feedback/submit`,
        submissionData,
        {
          headers: {
            'Content-Type': 'application/json',
          },
          timeout: 10000, // 10 second timeout
        }
      );

      return response.data;
    } catch (error) {
      console.error('Feedback submission error:', error);
      
      if (axios.isAxiosError(error)) {
        const errorMessage = error.response?.data?.message || error.message || 'Failed to submit feedback';
        return {
          success: false,
          message: errorMessage,
          error: errorMessage
        };
      }

      return {
        success: false,
        message: 'An unexpected error occurred while submitting feedback',
        error: 'Network error'
      };
    }
  }

  /**
   * Get user's feedback history (if authenticated)
   */
  async getUserFeedback(): Promise<any[]> {
    try {
      const token = localStorage.getItem('authToken');
      if (!token) {
        throw new Error('Authentication required');
      }

      const response = await axios.get(
        `${this.baseURL}/user/feedback`,
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          }
        }
      );

      return response.data.data || [];
    } catch (error) {
      console.error('Error fetching user feedback:', error);
      return [];
    }
  }
}

export const feedbackService = new FeedbackService();
export default feedbackService;
